export const MAX_NODES = Number.parseInt(process.env.REACT_APP_GRAPH_MAX_NODES, 10) || 200;
export const GRAPH_CACHE_TTL_MS = 3 * 60 * 1000;
export const GRAPH_CACHE_MAX_ENTRIES = 150;
export const IS_DEVELOPMENT = process.env.NODE_ENV !== 'production';
export const EXPANSION_HOPS_LIMIT = 2;
export const GRAPH_VIEWPORT_HEIGHT = 'clamp(420px, 72vh, 700px)';
export const GRAPH_ZOOM_STEP = 0.2;
export const GRAPH_PAN_STEP = 60;
export const GRAPH_RING_BASE_RADIUS = 180;
export const GRAPH_RING_RADIUS_STEP = 120;
export const GRAPH_RING_MIN_SPACING = 94;
export const EXPANSION_NODE_SCALE_FACTOR = 3.24;
export const EXPANSION_NODE_MAX_DISTANCE = 990;
export const EXPANSION_RING_BUFFER = 0;
export const EXPANSION_RING_MIN_SPACING = 94;
export const GRAPH_FIT_PADDING = 140;
export const GRAPH_EXPANSION_FIT_PADDING = 140;
